import type { CSSProperties } from "react";
import {
  productSliderScrollBottomCtaAlignTokens,
  productSliderScrollBottomCtaVariantTokens,
  type ProductSliderScrollBottomCtaAlign,
  type ProductSliderScrollBottomCtaVariant,
} from "./ProductSliderScroll.tokens";

export const productSliderScrollStyles = {
  contentWrap: {
    display: "grid",
    gap: "24px",
  } satisfies CSSProperties,

  bottomCtaWrap: {
    display: "flex",
    width: "100%",
    marginTop: "2px",
  } satisfies CSSProperties,

  bottomCtaButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "44px",
    padding: "12px 20px",
    borderRadius: "999px",
    border: "1px solid transparent",
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: 1,
    textDecoration: "none",
    whiteSpace: "nowrap",
    transition:
      "background 160ms ease, border-color 160ms ease, color 160ms ease, transform 160ms ease",
  } satisfies CSSProperties,
};

export function getProductSliderScrollBottomCtaWrapStyle(
  align: ProductSliderScrollBottomCtaAlign = "center"
): CSSProperties {
  return {
    ...productSliderScrollStyles.bottomCtaWrap,
    justifyContent: productSliderScrollBottomCtaAlignTokens[align],
  };
}

export function getProductSliderScrollBottomCtaButtonStyle(
  variant: ProductSliderScrollBottomCtaVariant = "primary"
): CSSProperties {
  return {
    ...productSliderScrollStyles.bottomCtaButton,
    ...productSliderScrollBottomCtaVariantTokens[variant].button,
  };
}
